// @flow

import React, { PureComponent } from "react";
import styled from "styled-components";

const SVG = styled.svg`
  display: block;
  height: 135px;
`;

export default class PowerRating extends PureComponent<*> {
  render() {
    return (
      <SVG viewBox="0 0 374 134">
        <defs>
          <filter
            x="-.1%"
            y="-.4%"
            width="100.3%"
            height="100.7%"
            filterUnits="objectBoundingBox"
            id="b"
          >
            <feOffset dy="-1" in="SourceAlpha" result="shadowOffsetInner1" />
            <feComposite
              in="shadowOffsetInner1"
              in2="SourceAlpha"
              operator="arithmetic"
              k2="-1"
              k3="1"
              result="shadowInnerInner1"
            />
            <feColorMatrix
              values="0 0 0 0 0.811764706 0 0 0 0 0.839215686 0 0 0 0 0.858823529 0 0 0 1 0"
              in="shadowInnerInner1"
            />
          </filter>
          <filter
            x="0%"
            y="0%"
            width="100%"
            height="100%"
            filterUnits="objectBoundingBox"
            id="c"
          >
            <feGaussianBlur in="SourceGraphic" />
          </filter>
          <filter
            x="-6.3%"
            y="-12.5%"
            width="112.5%"
            height="112.5%"
            filterUnits="objectBoundingBox"
            id="d"
          >
            <feGaussianBlur in="SourceGraphic" />
          </filter>
          <path id="a" d="M0 0h374v134H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <use fill="#F8FBFF" />
          <use fill="#000" />
          <path
            d="M74.8 26c4.957 0 8.976 4.03 8.976 9s-4.019 9-8.976 9c-4.957 0-8.976-4.03-8.976-9 0-.687.077-1.357.222-2h2.062a7.019 7.019 0 00-.29 2c0 3.866 3.126 7 6.982 7 3.856 0 6.981-3.134 6.981-7s-3.125-7-6.98-7l-.001-2z"
            fill="#1493FF"
          />
          <ellipse
            fill="#EBF6FF"
            filter="url(#c)"
            cx="187.499"
            cy="109"
            rx="29.92"
            ry="3"
          />
          <path
            d="M182.062 73.055h-19.03a3.338 3.338 0 01-3.054-1.983 3.362 3.362 0 01.555-3.596l37.546-42.351a3.35 3.35 0 014.113-.713 3.36 3.36 0 011.606 3.86l-8.17 28.665h19.03c1.32 0 2.512.773 3.053 1.979a3.362 3.362 0 01-.549 3.6l-37.547 42.354a3.345 3.345 0 01-2.503 1.126 3.39 3.39 0 01-1.613-.416 3.36 3.36 0 01-1.606-3.86l8.17-28.665z"
            stroke="#E8B436"
            strokeWidth="2"
            fill="#FFCB4D"
          />
          <path
            d="M182.062 72.055h-19.03a3.338 3.338 0 01-3.054-1.983 3.362 3.362 0 01.555-3.596l37.546-42.351a3.35 3.35 0 014.113-.713 3.36 3.36 0 011.606 3.86l-8.17 28.665h19.03c1.32 0 2.512.773 3.053 1.979a3.362 3.362 0 01-.549 3.6l-37.547 42.354a3.345 3.345 0 01-2.503 1.126 3.39 3.39 0 01-1.613-.416 3.36 3.36 0 01-1.606-3.86l8.17-28.665z"
            stroke="#E8B436"
            strokeWidth="2"
            fill="#FFCB4D"
          />
          <path
            d="M216.799 58.325a2.36 2.36 0 01-.385 2.527l-37.547 42.353a2.345 2.345 0 01-2.886.5 2.36 2.36 0 01-1.126-2.711C190.032 80.06 194.91 68.729 189.493 67c-5.417-1.73-2.306-15.8 9.335-42.214a2.35 2.35 0 012.882-.498 2.36 2.36 0 011.126 2.71l-8.532 29.94h20.355c.924 0 1.76.54 2.14 1.387z"
            fill="#FFD87A"
          />
          <path
            d="M133.142 52.13a7.47 7.47 0 00-10.218 2.745c-2.066 3.587-.84 8.174 2.738 10.245"
            stroke="#3DD96F"
            strokeWidth="2"
          />
          <ellipse
            stroke="#36C565"
            strokeWidth="2"
            cx="272.771"
            cy="30.5"
            rx="6.483"
            ry="6.5"
          />
          <path
            d="M93.75 96a4.993 4.993 0 004.986-5c0-2.761-2.233-5-4.987-5a4.993 4.993 0 00-4.986 5"
            stroke="#FFCB4D"
          />
          <path
            d="M286.242 106.977c.005-4.415-3.566-7.99-7.975-7.985-4.41.005-7.988 3.588-7.993 8.004"
            stroke="#3DD96F"
            strokeWidth="2"
            filter="url(#d)"
            transform="rotate(150 278.258 102.994)"
          />
          <path
            d="M300.524 55.786a3 3 0 002.116-3.674 2.991 2.991 0 00-3.665-2.122"
            stroke="#FFE39E"
            strokeWidth="2"
          />
          <path
            d="M252.325 78c4.958 0 8.976-4.03 8.976-9s-4.018-9-8.976-9c-4.957 0-8.976 4.03-8.976 9"
            stroke="#1493FF"
            strokeWidth="2"
          />
        </g>
      </SVG>
    );
  }
}
